import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/**
 * items: [{ label: string, to?: string }]
 * Le dernier item est considere comme la page courante (non clickable).
 */
// ⚠️ 13 px et non 11 (item M3, arbitre par Boubacar le 30/08).
//
// Le tableau de bord monte toutes ses tailles de deux pixels avec un plancher a douze.
// Le fil d Ariane y restait le SEUL texte sous ce plancher, et il se lit juste au-dessus
// du titre : le laisser en arriere se voyait a l oeil.
//
// Ce composant est PARTAGE par quinze ecrans. Le changement les monte donc TOUS de deux
// pixels, et c est assume : c est la meme regle, appliquee au meme endroit du haut de
// chaque page. Un fil d Ariane a deux tailles selon l ecran aurait ete pire.
export default function Breadcrumb({ items = [] }) {
  return (
    <nav
      aria-label="Fil d'Ariane"
      className="flex items-center gap-1 text-[13px] text-neutral-400 mb-2"
      data-testid="breadcrumb"
    >
      <Link
        to="/dashboard"
        className="flex items-center gap-1 min-h-11 md:min-h-0 hover:text-neutral-700 transition-colors"
        data-testid="breadcrumb-home"
      >
        <Home className="w-3 h-3" />
        <span>Accueil</span>
      </Link>
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={idx} className="flex items-center gap-1">
            <ChevronRight className="w-3 h-3 text-neutral-300" />
            {isLast || !item.to ? (
              <span
                className={isLast ? 'font-medium text-neutral-700' : ''}
                data-testid={`breadcrumb-item-${idx}`}
              >
                {item.label}
              </span>
            ) : (
              <Link
                to={item.to}
                className="hover:text-neutral-700 transition-colors"
                data-testid={`breadcrumb-link-${idx}`}
              >
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
